import VehiclesError from './VehiclesError.js'

export class GetSubscriptionMakesNotFoundVehiclesError extends VehiclesError {}
